import supplierTerms from "./supplierTerms.json";
export const getSupplierTerms = (supplier) => {
    return supplierTerms[supplier];
};
export const getSupplierTermsForPOS = (supplier, pos) => {
    const supplierTermsByPOS = getSupplierTerms(supplier);
    const pointOfSale = pos.toUpperCase();
    return supplierTermsByPOS.hasOwnProperty(pointOfSale)
        ? supplierTermsByPOS[pointOfSale]
        : undefined;
};
export const getSupplierTermsUrl = (pointOfSale, anchor) => {
    return `https://flights-${pointOfSale.toLowerCase() === "gb" ? "uk" : pointOfSale}.gotogate.com/rf/travel-conditions${anchor ? `#${anchor}` : ""}`;
};
export const getSupplierLegalName = (pointOfSale) => {
    if (!pointOfSale) {
        return undefined;
    }
    return getSupplierTermsForPOS("ETG", pointOfSale)?.name;
};
